<template>
    <div class="attachments">
        <div class="attachments__wrapper ma-6">
            <div class="attachments-wrapper__title font-weight-bold text--secondary" v-if="currentDocument">
                {{ currentDocument.documentName }}
            </div>
            <hr class="mb-4" />
            <div class="attachments-wrapper__title font-weight-bold mb-4">
                {{ $t("attachments.title") }}
            </div>
            <div
              class="attachments-wrapper__description text--secondary mb-8"
              v-if="attachmentsComments"
              v-html="attachmentsComments">
            </div>
            <Alerts v-if="!uploadedFiles.length && showAlert" :alertType="alertType" :alertMsg="alertMsg" />

            <div v-for="(file, index) in uploadedFiles" :key="index" class="custom-dropzone__file-item">
                <div class="file-name overflow-hidden">
                    <span class="bullet"></span>
                    <span class="text-truncate">{{ getTrimmedFileName(file.filename) }}</span>
                </div>
                <div>
                    <v-icon @click="removeFile(index)">mdi-delete</v-icon>
                    <!-- <a @click="downloadFile(index)"><v-icon>mdi-download</v-icon></a> -->
                </div>
            </div>
            <div class="attachments__dropzone-title font-weight-bold">
                {{ $t("attachments.doc-list-title") }}
            </div>
            <div class="attachments__dropzone-area mt-3">
                <custom-dropzone-component @files="uploadFiles" />
            </div>



        </div>
        <div class="footer-message">
            <div>
                <v-row>
                    <v-container class="py-0 fill-height">
                        <div class="col-md-12 col-12 reject pr-0 mt-6 text-center">
                            <v-btn large class="footer-text-btn" block dark @click="save()">
                                {{ $t("attachments.button-text") }}
                            </v-btn>
                        </div>
                    </v-container>
                </v-row>
            </div>
        </div>
        <default-loading v-if="loading" :loading="loading" />
    </div>
</template>

<script>
import CustomDropzoneComponent from './shared/Dropzone.component.vue'
import UploadService from '../services/upload-service.js'
import DefaultLoading from "./shared/DefaultLoading.component"
import Alerts from "../components/shared/Alerts.component";
import { mapGetters } from 'vuex';

export default {
    components: {
        CustomDropzoneComponent,
        DefaultLoading,
        Alerts
    },
    data() {
        return {
            loading: false,
            uploadedFiles: [],
            showAlert: false,
            alertType: "",
            alertMsg: "",
            token: null,
            authId: null,
            currentDocument: null,
            attachmentsComments: ""
        }
    },
    computed: {
        getTrimmedFileName() {
            return (fileName) => {
                const maxLength = 100
                if (fileName.length > maxLength) {
                    const trimmedName = fileName.substring(0, maxLength - 3) + '...';
                    return trimmedName
                }
                return fileName
            }
        },
        hasSignerForm() {
            return this.$store.getters['forms/hasSignerForm']
        },
        hasPendingSignerForm() {
            return this.$store.getters['forms/hasPendingSignerForm']
        },
        hasAssociation() {
            return this.$store.getters['common/hasAssociation']
        },
        currentRoute() {
            return this.$route;
        },
        documentCheckList() {
            return localStorage.getItem("documentCheckList") ? JSON.parse(localStorage.getItem("documentCheckList")) : [];
        },
        ...mapGetters('attachments', [
            'hasAttachments', 'getTransactionApiToken'
        ]),
        ...mapGetters('forms', [
            'hasSignerForm', 'hasPendingSignerForm'
        ])
    },
    methods: {
        loadAttachmentsComments() {
            console.log("Dentro de loadAttachmentComments");
            this.loading = true;
            console.log("llamando a API");
            console.log("authId en attachments: " + this.authId);
            this.$store
                .dispatch("common/getRequestData", {
                    token: this.token,
                    requestId: this.requestid,
                    authId: this.authId,
                })
                .then((response) => {
                    this.loading = false;
                    const signRequest = response.data;
                    this.attachmentsComments = signRequest.attachmentsComments;
                    console.log("Comentarios de Anexos: " + this.attachmentsComments);
                })
                .catch(() => {
                    this.loading = false;
                });
        },

        async loadAttachments() {
            if (this.token) {
                const attachments = await UploadService.getAttachments(this.$route.params.id, this.$route.query.token, this.$route.query.auth_id);
                this.uploadedFiles = attachments.data
            }
        },

        setAlert(show, alertType, alertMsg) {
            this.showAlert = show;
            this.alertType = alertType;
            this.alertMsg = alertMsg;
        },
        async save() {
            try {
                console.log("Ejecutando loadFormStatus");
//                await this.loadFormStatus(); // Espera a que se complete loadFormStatus

                // Obtener token desde localStorage si no está en la URL
                const token = localStorage.getItem('auth_user_token') || localStorage.getItem('access_token');
                const authId = this.$route.query.authId;
                console.log("Uploaded Files: " + this.uploadedFiles.length);
                console.log("hasSignerForm y hasPendingSignerForms" + this.hasSignerForm + this.hasPendingSignerForm);

                if (this.uploadedFiles.length > 0) {
                    let routeName = `${this.hasAssociation ? 'custom-' : ''}`;

                    if (this.hasSignerForm && this.hasPendingSignerForm) {
                        routeName += 'forms';
                    } else {
                        routeName += 'pdf-viewer';
                    }

                    // Construcción dinámica de query params
                    const queryParams = {};
                    if (token) queryParams.token = token;
                    if (authId !== null && authId !== undefined) queryParams.auth_id = authId;

                    // Redirección
                    this.$router.push({
                        name: routeName,
                        query: queryParams
                    });
                } else {
                    this.setAlert(true, 'error', this.$t("attachments.upload-required-message"));
                }
            } catch (error) {
                console.error('Error in save method:', error);
            }
        },
        async uploadFiles(files) {
            this.loading = true
            const response = await UploadService.uploadAttachments(this.requestid, files, this.token, this.auth_id)
            this.uploadedFiles.push(response.data)
            this.loading = false
        },

        async downloadFile(index) {
            this.loading = true
            const response = await UploadService.downloadAttachments(this.$route.params.id, this.uploadedFiles[index].id, this.token, this.authId)
            const blob = new Blob([response.data], { type: 'application/pdf' })
            const url = URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            link.download = 'document.pdf'
            link.click()
            URL.revokeObjectURL(url)
            this.loading = false
        },
        async removeFile(index) {
            this.loading = true
            await UploadService.removeAttachments(this.$route.params.id, this.uploadedFiles[index].id, this.token, this.authId)
            this.uploadedFiles.splice(index, 1)
            this.loading = false
        },
        findCurrentDocument() {
            // let currentDoc = this.documentCheckList.filter((document) => document.documentId == this.currentRoute.params.id);
            // this.currentDocument = currentDoc && currentDoc.length ? currentDoc[0] : null;
            this.loadAttachments();

        },
        async loadFormStatus() {
            try {
                const response = await this.$store.dispatch('forms/getFormStatus', {
                    requestId: this.$route.params.id,
                    token: this.token,
                    authId: this.authId
                });
                return response;
            } catch (error) {
                console.error('Error loading form status:', error);
                throw error; // Re-throw the error to be caught in the save method
            }
        }
    },
    mounted() {

        // if (this.currentRoute && this.currentRoute.params.id) {
        this.findCurrentDocument()
        // }
      this.token = this.$route.query.token || null;
      this.authId = this.$route.query.auth_id || null;
      this.requestid = localStorage.getItem("request_id")
      this.token = localStorage.getItem("auth_user_token")
          || localStorage.getItem("access_token")
          || this.$route.query.token
          || null;
      this.loadAttachmentsComments();
    },

    created() {

    }
}
</script>

<style scoped>
.attachments__wrapper {
    background: #f9f9f9;
    padding: 20px;
    border-radius: 10px;
}

.attachments-wrapper__title {
    font-size: 18px;
    margin-bottom: 10px;
}

.custom-dropzone__file-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    margin: 5px 0;
    background: rgba(243, 110, 33, 0.1);
    /* Light background color derived from theme color */
    border: 1px solid #ddd;
    border-radius: 5px;
}

.custom-dropzone__file-item v-icon {
    cursor: pointer;
}

.file-name {
    display: flex;
    align-items: center;
}

.bullet {
    width: 10px;
    height: 10px;
    background-color: #f36e21;
    border-radius: 50%;
    display: inline-block;
    margin-right: 10px;
}

.custom-dropzone__file-item {
    display: flex;
    justify-content: space-between;
}
</style>